import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getListOfSources: (params, filterSourceIds) =>
      `${baseURL}/api/sources?t=${new Date().getTime()}&${encodeParams(
        params
      )}`,
    getListOfStatus: (idSource, params) =>
      `${baseURL}/api/sources/${idSource}/status?${encodeParams(params)}`,
    deleteSource: (idSource) =>
      `${baseURL}/api/sources/${encodeURIComponent(idSource)}`,
    getSource: (idSource) =>
      `${baseURL}/api/sources/${encodeURIComponent(idSource)}`,
    getListOfContents: (idSource, params) =>
      `${baseURL}/api/sources/${encodeURIComponent(
        idSource
      )}/contents?${encodeParams(params)}`,
    insertSource: () => `${baseURL}/api/sources`,
    updateContents: (idSource, params) =>
      `${baseURL}/api/sources/${encodeURIComponent(
        idSource
      )}/contents?${encodeParams(params)}`,
    searchSourceActivity: (idSource, params) =>
      `${baseURL}/api/sources/${encodeURIComponent(
        idSource
      )}/activities?${encodeParams(params)}`,
    getSourceActivity: (idSource, idActivity) =>
      `${baseURL}/api/sources/${encodeURIComponent(
        idSource
      )}/activity/${encodeURIComponent(idActivity)}`,
    updateFile: (idSource) =>
      `${baseURL}/api/sources/${encodeURIComponent(idSource)}/fileupdate`
  }
})(process.env.CONTENTS_SOURCE_URL)

export const beContentSourceGetListOfSources = (params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfSources(params)
  }).then(({ data }) => {
    return data
  })
}

export const beContentSourceGetListOfStatus = (idSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfStatus(idSource, params)
  }).then(({ data }) => {
    return data
  })
}

export const beContentSourceDeleteSource = (idSource) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteSource(idSource)
  }).then(({ data }) => data)
}

export const beContentSourceGetSource = (idSource) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSource(idSource)
  }).then(({ data }) => data)
}

export const beContentSourceGetListOfContents = (idSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfContents(idSource, params)
  }).then(({ data }) => data)
}

export const beContentInsertSource = (data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.insertSource(),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beContentUpdateContents = (idSource, params) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.updateContents(idSource, params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beContentSourceApiGetSearchSourceActivity = (idSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.searchSourceActivity(idSource, params)
  }).then(({ data }) => data)
}

export const beContentsSourceApiUpdateSource = (idSource, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.getSource(idSource),
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beContentSourceApiGetSourceActivity = (idSource, idActivity) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSourceActivity(idSource, idActivity)
  }).then(({ data }) => {
    return data
  })
}

export const beContentSourceApiUpdateSourceFromFile = (idSource, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.updateFile(idSource),
    data
  }).then(({ data }) => data)
}
